import React, { FC } from 'react';
import { responsibilities } from '../../utils/data';

interface Responsibility {
  id: number;
  title: string;
  organization: string;
  location: string;
  period: string;
  description: string;
}

const Responsibility: FC = () => {
  return (
    <div className="responsibility-section">
      <div className="responsibility-content">
        <h2 className="section-title">Positions of Responsibility</h2>
        
        <div className="responsibilities-grid">
          {responsibilities.map((position: Responsibility) => (
            <div className="responsibility-card" key={position.id}>
              <div className="responsibility-header">
                <div className="responsibility-title">{position.title}</div>
                <div className="responsibility-org">{position.organization}</div>
              </div>
              
              <div className="responsibility-details">
                <div className="responsibility-meta">
                  <div className="responsibility-location">
                    <i className="fas fa-map-marker-alt"></i> {position.location}
                  </div>
                  <div className="responsibility-period">
                    <i className="far fa-calendar-alt"></i> {position.period}
                  </div>
                </div>
                
                <div className="responsibility-desc">
                  {position.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <style>
        {`
        .responsibility-section {
          min-height: 100vh;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 80px 0;
        }
        
        .responsibility-content {
          width: 100%;
          max-width: 1200px;
          padding: 0 20px;
        }
        
        .section-title {
          font-size: 42px;
          color: #00ff00;
          margin-bottom: 40px;
          text-align: center;
          text-shadow: 0 0 10px rgba(0, 255, 0, 0.7);
          font-family: 'VT323', monospace;
          letter-spacing: 3px;
        }
        
        .responsibilities-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 30px;
        }
        
        .responsibility-card {
          background-color: rgba(0, 0, 0, 0.7);
          border: 1px solid #00ff00;
          border-radius: 5px;
          overflow: hidden;
          transition: all 0.3s ease;
          box-shadow: 0 0 15px rgba(0, 255, 0, 0.3);
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        
        .responsibility-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 0 20px rgba(0, 255, 0, 0.6);
        }
        
        .responsibility-header {
          background-color: rgba(0, 50, 0, 0.5);
          padding: 20px;
          border-bottom: 1px solid #00ff00;
        }
        
        .responsibility-title {
          font-family: 'VT323', monospace;
          font-size: 22px;
          color: #00ff00;
          margin-bottom: 5px;
        }
        
        .responsibility-org {
          color: #00ff00;
          font-size: 18px;
        }
        
        .responsibility-details {
          padding: 20px;
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        
        .responsibility-meta {
          display: flex;
          justify-content: space-between;
          margin-bottom: 15px;
          flex-wrap: wrap;
        }
        
        .responsibility-location, .responsibility-period {
          color: #00ff00;
          font-size: 14px;
          opacity: 0.8;
          margin-right: 10px;
          margin-bottom: 5px;
        }
        
        .responsibility-desc {
          color: #00ff00;
          font-size: 16px;
          line-height: 1.5;
        }
        
        @media (max-width: 768px) {
          .responsibilities-grid {
            grid-template-columns: 1fr;
          }
        }
        `}
      </style>
    </div>
  );
};

export default Responsibility;